
export function inputTitleStyle(components, core) {
  return {
    position: 'absolute',
    top: '-30px',
    color: `${core.palette.neutralPrimary}`,
    fontWeight: '500',
  };
}
